import { render, staticRenderFns } from "./puntuation-editar.vue?vue&type=template&id=4c2b653d&scoped=true&"
import script from "./puntuation-editar.vue?vue&type=script&lang=js&"
export * from "./puntuation-editar.vue?vue&type=script&lang=js&"
import style0 from "./puntuation-editar.vue?vue&type=style&index=0&id=4c2b653d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b653d",
  null
  
)

export default component.exports